import { createFileRoute } from "@tanstack/react-router";
import { General } from "../../../features/settings/general";

export const Route = createFileRoute("/_authed/$org/settings/general")({ component: GeneralPage });

function GeneralPage() {
  return <General org={Route.useParams().org} />;
}
